// TODO: Fix no-non-null assertions
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { BaseActivityEvent } from './BaseActivityEvent'
import { Actor } from './Actor'
import { ArticleInformalFeedbackReviewSubmittedEvent, BaseActivityEventProps } from './Types'
import { InformalFeedbackRequestAction } from './InformalFeedbackRequestAction'
import { ProseDisplay } from 'common/ProseInput/ProseDisplay'
import { Approved, Feedback, Rejected } from 'blaze-ui/icons/20'
import { useModals } from 'almanac-ui/Modal'
import { ReviewSummaryModal } from 'components/ReviewSummaryModal/ReviewSummaryModal'

interface Props extends Partial<BaseActivityEventProps> {
  event: ArticleInformalFeedbackReviewSubmittedEvent
}

const SCORE_ICONS = {
  30: Approved,
  20: Feedback,
  10: Rejected,
}

const SCORE_VERBS = {
  30: 'approved',
  20: 'left feedback',
  10: 'sent back for another round',
}

const ArticleInformalFeedbackReviewSubmitted = ({ event, ...props }: Props) => {
  const {
    user,
    data: { message, score, request_id },
  } = event
  const { actions, ...rest } = props
  const Icon = SCORE_ICONS[score!]
  const { openModal } = useModals()

  const handleClick = (e: MouseEvent) => {
    openModal(ReviewSummaryModal, { requestId: request_id })
  }

  return (
    <>
      <BaseActivityEvent
        {...rest}
        onClick={handleClick}
        icon={<Icon size={24} />}
        timestamp={event.timestamp}
        message={message && <ProseDisplay html={message} />}
        content={
          <>
            <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> {SCORE_VERBS[score!]}
          </>
        }
        actions={
          <>
            <InformalFeedbackRequestAction event={event} />
            {actions}
          </>
        }
      />
    </>
  )
}

export { ArticleInformalFeedbackReviewSubmitted }
